module.exports = __webpack_public_path__ + "static/media/background.5e877801.png";